import { Notification, restRepository } from "@onair/repositories";
import fetcher from "@onair/utils/fetch-api";

import { useNotiStore } from "./store";

export const actionMaskAsReadAll = async () => {
	const res = await restRepository.api.maskAsReadAllNotifications();

	useNotiStore.setState((old) => {
		return { ...old, total: 0 };
	});

	return res;
};

export const actionCountNotiUnread = async () => {
	const { data } = await restRepository.api.countUnreadNotifications();

	useNotiStore.setState((old) => {
		return { ...old, total: data.total };
	});

	return data;
};

export const actionMaskAsRead = async (id: string) => {
	const res = await restRepository.api.updateNotification(id, {
		read: true,
	});

	useNotiStore.setState((old) => {
		return { ...old, total: old.total - 1 };
	});

	return res;
};
